import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { copy } from "shared/assets";
import { IAPIState, IFormButtons, IStatus } from "shared/types";
import { buildUrl } from "shared/utils";
import { addTemporaryToast } from "shared/components/Toast";
import { VENUE_PATHS } from "Venues/router";
import { VenueForm } from "Venues/components";
import { IVenue, IVenuePostData, VENUE_ACTIONS } from "Venues/types";
import { createVenue, dataMetaSelector } from "Venues/state";
import { useClearActionMetaOnUnMount } from "Venues/utils";

const buttons: IFormButtons = {
  primary: {
    children: copy.createVenue.submit.venue,
    size: "huge",
    isFullWidth: true,
    "data-testid": "create_venue_button",
  },
};

interface CreateVenueProps {
  updatePlaceholder?: (venue: IVenue) => void;
}

export const CreateVenue: React.FC<CreateVenueProps> = ({
  updatePlaceholder,
}) => {
  const { api: apiMeta, id: venueId } = useSelector(
    dataMetaSelector(VENUE_ACTIONS.createVenue)
  );
  useClearActionMetaOnUnMount(VENUE_ACTIONS.createVenue);

  const dispatch = useDispatch();
  const history = useHistory();

  const handleSubmit = (venue: IVenuePostData) => {
    dispatch(createVenue({ venue }));
  };

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded && venueId) {
      history.push(buildUrl(VENUE_PATHS.VENUE, { venueId }));
      dispatch(
        addTemporaryToast({
          message: copy.createVenue.success,
          status: IStatus.success,
        })
      );
    }
  }, [apiMeta, dispatch, history, venueId]);

  return (
    <VenueForm
      apiStatus={apiMeta?.status}
      hasError={!!apiMeta?.error}
      buttons={buttons}
      handleSubmit={handleSubmit}
      updatePlaceholder={updatePlaceholder}
    />
  );
};
